import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import FilterMenu from 'srcReact/components/common2/FilterMenu'
import { urlSearchParams } from 'srcReact/helpers/utils'
import All from 'srcReact/SearchPage/components/All'
import Groups from 'srcReact/SearchPage/components/Groups'
import Mixrs from 'srcReact/SearchPage/components/Mixrs'
import Members from 'srcReact/SearchPage/components/Members'
import Media from 'srcReact/SearchPage/components/Media'
import Posts from 'srcReact/SearchPage/components/Posts'
import { globalSearchActions } from 'srcReact/SearchPage'
import { checkNested } from 'srcReact/helpers/validator'
import Spinner from 'srcReact/components/common2/Spinner'
import history from 'srcReact/helpers/history'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

export default function GlobalSearchPopin({ isHeader, closeModal }) {
  const { t } = useTranslation()
  const containerRef = useRef()

  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative, userLocation },
    globalSearch: { searchText, searchInterestText, loading, loaded, stat, filters, filterItem },
    organization: { current_organization }
  } = useSelector((state) => state)

  const [isBackNavigation] = useState(true)

  useEffect(() => {
    containerRef.current.addEventListener('keydown', handleKeyPress, false)
    return function cleanup() {
      containerRef.current.removeEventListener('keydown', handleKeyPress, false)
    }
  }, [])

  useEffect(() => {
    if (isNative) {
      dispatch(
        globalSearchActions.globalSearch(
          urlSearchParams('organization_id'),
          searchText,
          urlSearchParams('lat'),
          urlSearchParams('lon'),
          filterItem
        )
      )
      return
    }
    if (checkNested(current_organization, 'info', 'id') && userLocation) {
      dispatch(
        globalSearchActions.globalSearch(
          current_organization.info.id,
          searchText,
          userLocation.latitude,
          userLocation.longitude,
          filterItem
        )
      )
    }
  }, [searchText, filterItem])

  const setFilterItem = (filter) => {
    dispatch(globalSearchActions.setFilterItem(filter))
  }

  const renderSearchContent = () => {
    const commonProps = {
      isMobile,
      isNative,
      isHeader,
      isBackNavigation,
      closeModal
    }
    switch (filterItem) {
      case 'all':
        return <All {...commonProps} />
      case 'mixrs':
      case 'my_mixrs':
        return <Mixrs {...commonProps} />
      case 'groups':
      case 'my_groups':
        return <Groups {...commonProps} />
      case 'members':
        return <Members {...commonProps} />
      case 'media':
        return <Media {...commonProps} />
      case 'posts':
        return <Posts {...commonProps} />
    }
  }
  const handleKeyPress = (e) => {
    if (e.key === 'Tab') {
      const focusableElements = containerRef.current.querySelectorAll('button, [href], input, select, textarea')

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (e.shiftKey && document.activeElement === firstElement) {
        // Shift + Tab, focus the last focusable element
        e.preventDefault()
        lastElement.focus()
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        // Tab, focus the first focusable element
        e.preventDefault()
        firstElement.focus()
      }
    } else if (event.key === 'Escape' && closeModal) {
      closeModal()
    }
  }

  return (
    <div id='globalsearch_popin' ref={containerRef} className={styles.globalSearchPopinWrapper}>
      {searchText?.length > 1 && <div className={styles.searchText}>{`“${searchText}"`}</div>}
      <FilterMenu
        filterItems={t('globalSearch.filterItems', { returnObjects: true })}
        filterItem={filterItem}
        setFilterItem={setFilterItem}
        filterStats={filters}
        filterClassName={styles.filterClassName}
        buttonClassName={styles.buttonClassName}
        hasTabCount={true}
      />
      {loaded && (
        <React.Fragment>
          <div className={styles.searchContent}>{renderSearchContent()}</div>
          <AnchorLink
            isNative={isNative}
            className={styles.seeAllResults}
            path='/0/search'
            onMouseDown={(e) => e.preventDefault()}>
            {t('globalSearch.seeAllResults', { total: stat.total })}
          </AnchorLink>
        </React.Fragment>
      )}
      {loading && !loaded && <Spinner />}
    </div>
  )
}
